import styled from "@emotion/styled";
import {
    breakpoints,
    colors,
    fontWeights,
    mediaQuery,
    zIndexes,
} from "@gumtree/ui-library/src/base/theme";

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: ${zIndexes.high};
    display: flex;
    align-items: center;
    justify-content: center;

    ${mediaQuery.until(breakpoints.medium)} {
        align-items: flex-end;
    }
`;

export const BannerContainer = styled.div`
    background: ${colors.white};
    border-radius: 8px;
    width: 620px;
    padding: 16px 24px 32px;
    position: relative;
    box-sizing: border-box;
    text-align: center;

    ${mediaQuery.until(breakpoints.medium)} {
        width: 100%;
        border-radius: 16px 16px 0 0;
        padding: 16px 16px 32px;
        max-height: 90vh;
        overflow-y: auto;
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 24px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    line-height: 1;
    font-size: 20px;
    color: #1f2f3b;
    -webkit-tap-highlight-color: transparent;

    ${mediaQuery.until(breakpoints.medium)} {
        right: 16px;
    }

    &:hover {
        opacity: 0.7;
    }
`;

export const IllustrationWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 8px 0 16px;

    img {
        width: 180px;
        height: 120px;
        object-fit: contain;
    }

    ${mediaQuery.until(breakpoints.medium)} {
        img {
            width: 150px;
            height: 100px;
        }
    }
`;

export const Title = styled.h2`
    font-family: "Readex Pro", sans-serif;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #1f2f3b;
    margin: 0 0 8px;
    text-align: center;

    ${mediaQuery.until(breakpoints.medium)} {
        font-size: 20px;
        line-height: 28px;
    }
`;

export const Description = styled.p`
    font-family: "Readex Pro", sans-serif;
    font-weight: 330;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.15px;
    color: #3c3241;
    margin: 0 0 24px;
    text-align: center;
`;

export const ButtonRow = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;

    ${mediaQuery.until(breakpoints.medium)} {
        flex-direction: column-reverse;
    }
`;

export const PrimaryButton = styled.button`
    height: 46px;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    background-color: ${colors.gtGreen};
    color: #0d475c;
    font-family: "Readex Pro", sans-serif;
    font-size: 15px;
    font-weight: ${fontWeights.bold};
    line-height: 22px;
    letter-spacing: 0.15px;
    cursor: pointer;
    white-space: nowrap;
    -webkit-tap-highlight-color: transparent;

    ${mediaQuery.until(breakpoints.medium)} {
        width: 100%;
    }

    &:hover {
        background-color: ${colors.newBrandHoverState};
    }
`;

export const SecondaryButton = styled.button`
    height: 46px;
    min-width: 160px;
    padding: 12px 22px;
    box-sizing: border-box;
    border: 1px solid #0d495c;
    border-radius: 4px;
    background-color: ${colors.white};
    color: #0d475c;
    font-family: "Readex Pro", sans-serif;
    font-size: 15px;
    font-weight: ${fontWeights.bold};
    line-height: 22px;
    letter-spacing: 0.15px;
    cursor: pointer;
    white-space: nowrap;
    -webkit-tap-highlight-color: transparent;

    ${mediaQuery.until(breakpoints.medium)} {
        width: 100%;
    }

    &:hover {
        background-color: rgba(13, 73, 92, 0.04);
    }
`;
